const MatchFilterTabs = ({ activeTab, onTabChange, onOpenSchedule }) => {
  return (
    <div className="mt-3 flex gap-2 items-center justify-center flex-wrap">
      <button
        type="button"
        className={`border border-[#0c8f2e] rounded-full h-[30px] px-[18px] font-semibold cursor-pointer ${
          activeTab === 'all' ? 'bg-[#006719] text-white' : 'bg-white text-[#2f2f2f]'
        }`}
        onClick={() => onTabChange('all')}
      >
        Tất cả
      </button>
      <button
        type="button"
        className={`border border-[#0c8f2e] rounded-full h-[30px] px-[18px] font-semibold cursor-pointer ${
          activeTab === 'today' ? 'bg-[#006719] text-white' : 'bg-white text-[#2f2f2f]'
        }`}
        onClick={() => onTabChange('today')}
      >
        Hôm nay
      </button>
      <button
        type="button"
        className={`border border-[#0c8f2e] rounded-full h-[30px] px-[18px] font-semibold cursor-pointer ${
          activeTab === 'tomorrow' ? 'bg-[#006719] text-white' : 'bg-white text-[#2f2f2f]'
        }`}
        onClick={() => onTabChange('tomorrow')}
      >
        Ngày mai
      </button>
      <button
        type="button"
        className="border border-[#0c8f2e] rounded-full h-[30px] px-[18px] font-semibold cursor-pointer bg-[#006719] text-white"
        onClick={onOpenSchedule}
      >
        Lịch thi đấu
      </button>
    </div>
  );
};

export default MatchFilterTabs;

